module.exports = __webpack_public_path__ + "static/media/Logo.3ca3fcee.png";